import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const loadingSelector = createSelector(selfSelector, (analytic) => analytic.loading);

export default loadingSelector;
